<!-- BACUploadFile -->
<template>
    <!-- start navigator -->
    <div class="container ps-lg-5 pe-lg-5 mt-1">
        <div class="row">
            <div class="
            col-12
            d-none d-lg-flex
            justify-content-between
            align-items-center
          ">
                <nav style="--bs-breadcrumb-divider: '>'" aria-label="breadcrumb">
                    <ol class="breadcrumb">
                        <li class="breadcrumb-item">
                            <router-link class="text-decoration-none router-link"
                                to="/AgenteService">หน้าแรก</router-link>
                        </li>
                        <li class="breadcrumb-item" aria-current="page">
                            <router-link class="text-decoration-none router-link"
                                to="/AgenteService">ข้อมูลยื่นคำร้อง</router-link>
                        </li>
                        <li class="breadcrumb-item router-link active">
                            ขอทำบัตรประจำตัวผ่านเข้าออกอาคารสำนักงาน
                        </li>
                    </ol>
                </nav>
            </div>
        </div>
    </div>
    <!-- end navigator -->

    <div class="container-lg">
        <div class="row">
            <!-- Left Menu -->
            <div class="col-left-menu">
                <div class="left-menu">
                    <ul class="d-none d-lg-block">
                        <Menu />
                    </ul>
                </div>
            </div>
            <!-- Left Menu -->

            <div class="
          col-left-menu
          d-flex d-lg-none
          border-bottom
          align-items-center
          border-bottom
          w-100
          ps-3
          pe-3
        " style="background-color: #f2f2f2">
                <div class="icon-back">
                    <router-link to="/AgenteService">
                        <img src="@/assets/images/arrow-blue.svg" class="w-100" />
                    </router-link>
                </div>
                <div class="title ps-md-3 ps-lg-3 d-block d-lg-none text-center w-100 font-family blue-1">
                    ขอทำบัตรประจำตัวผ่านเข้าออกอาคารสำนักงาน
                </div>
            </div>

            <div class="col">

                <StepBar :steps="stepItems" :current="currentStep" />

                <div class="title d-none d-lg-block border-bottom font-family blue-1">
                    ขอทำบัตรประจำตัวผ่านเข้าออกอาคารสำนักงาน
                </div>

                <div class="font-family-bla my-3">
                    <div class="card-wrap p-4">
                        <div class="form-section">
                            <label class="field-label font-family-bla" style="font-size: 20px;">
                                แนบรูปถ่ายหน้าตรง <span class="required">*</span>
                            </label>
                            <p class="field-help font-family-bla" style="font-size: 20px;">
                                <span class="required">*</span>รูปถ่ายต้องเป็นไฟล์รูปถ่ายสี หน้าตรง พื้นหลังสีขาว
                            </p>
                            <p class="field-note ms-2 font-family-bla" style="font-size: 20px;">
                                อัปโหลดไฟล์ชนิด .jpg .jpeg .png เท่านั้น ขนาด 200 KB ขึ้นไปไม่เกิน
                                {{ this.manangeFiles.attachBAC.LIMIT_FILE_SIZE }}
                                MB
                            </p>

                            <!-- Drag and Drop area -->
                            <div class="col-12 col-md-6 col-sm-12 col-xl-6">
                                <input ref="fileBAC" type="file" accept=".jpg,.jpeg,.png" class="d-none" multiple
                                    @change="addBACFiles(Array.from($event.target.files)); $event.target.value = '';">
                                <button type="button" @click.prevent="$refs.fileBAC.click()"
                                    class="border btn btn-light shadow-sm w-100 w-sm-100 w-md-50 w-xl-50"
                                    :disabled="files.attachBAC.length >= manangeFiles.attachBAC.LIMIT_AMOUNT_FILE">
                                    <a class="fs-4 blue-1">แนบไฟล์</a>
                                </button>
                            </div>

                            <!-- แนบหลักฐานการใช้สิทธิ BAC -->
                            <div v-if="files.attachBAC.length" class="mt-3">
                                <div class="file-list-scroll">
                                    <div v-for="(file, index) in files.attachBAC" :key="file.id || index"
                                        class="file-chip mb-2 d-flex justify-content-between align-items-center"
                                        style="position: relative; padding-right: 40px;">
                                        <div class="d-flex align-items-start gap-2">

                                            <div>
                                                <span class="fw-bold">{{ file.name }}</span>
                                                <template v-if="isServerFile(file)">
                                                    <small class="text-muted"> (ไฟล์ที่มีอยู่แล้ว)</small>
                                                </template>
                                                <br />
                                                <small class="text-muted">{{ formatFileSize(file.size) }}</small>
                                            </div>
                                        </div>

                                        <font-awesome-icon :icon="faTrash"
                                            style="width:20px;height:20px;position:absolute;right:5px;top:50%;transform:translateY(-50%);cursor:pointer;color:red"
                                            @click="removeBAC(index)" />
                                    </div>
                                </div>
                            </div>

                        </div>


                    </div>

                    <!-- ปุ่มดำเนินการต่อ -->
                    <div class="text-end mt-4">
                        <button class="btn btn-bla w-25" @click="goNext">
                            ดำเนินการต่อ </button>
                    </div>

                </div>

            </div>

        </div>
    </div>

    <div v-if="this.Loading">
        <LoadingBs5></LoadingBs5>
    </div>
</template>

<script>
import Menu from "@/components/agenteservice/Menu.vue";
import { faCircleXmark, faTrash } from "@fortawesome/free-solid-svg-icons";

import LoadingBs5 from "@/components/frontend/LoadingBs5";
import http from "@/services/AuthService";
import Swal from 'sweetalert2/src/sweetalert2.js'

import '@/styles/SweetAlert2CustomCSS.css';

import StepBar from "../StepBar.vue";

export default {
    name: "BACUploadFile",
    components: {
        Menu,
        LoadingBs5,
        StepBar
    },
    data() {
        return {
            faCircleXmark: faCircleXmark,
            faTrash: faTrash,
            Loading: true,
            manangeFiles: {
                attachBAC: {// แนบหลักฐานการใช้สิทธิ BAC
                    LIMIT_AMOUNT_FILE: 1,// จำนวนไฟล์
                    LIMIT_FILE_SIZE: 2,// ขนาดไฟล์(mb)
                    REMARK: '',
                },
            },
            files: {
                attachBAC: [],// แนบหลักฐานการใช้สิทธิ BAC
            },
            reqCodeID: 78,
            currentStep: 2, // เพิ่ม state สำหรับ step ปัจจุบัน
            stepItems: ['เอกสารที่ต้องเตรียม', 'ประสงค์ขอทำบัตร', 'อัปโหลดเอกสาร', 'ชำระเงิน', 'เสร็จสิ้น'], // Default steps
        };
    },
    mounted() {
        if (this.$store.state.AgentCode == '') {
            this.$router.push('/');
        }

        this.Authorization();
        this.GetRequestDoc();
        this.determineSteps();
    },
    methods: {
        async determineSteps() {
            const baseSteps = ['เอกสารที่ต้องเตรียม', 'ประสงค์ขอทำบัตร', 'อัปโหลดเอกสาร'];
            const finalStep = 'เสร็จสิ้น';
            let requiresPayment = false;

            try {
                const reqType = this.$store.state.BuildingAccessCard.REQ_TYPE;

                if (reqType === 'REP') {
                    requiresPayment = true;
                } else if (reqType === 'NEW' || reqType === 'REN') {
                    const AuthorizeToken = localStorage.getItem("AuthorizeToken");
                    const response = await http.get('AgencyERequest/CheckPaymentByAgLavel', { headers: { Authorization: `Bearer ${AuthorizeToken}` } });
                    requiresPayment = response.data === true;
                }

                if (requiresPayment) {
                    this.stepItems = [...baseSteps, 'ชำระเงิน', finalStep];
                } else {
                    this.stepItems = [...baseSteps, finalStep];
                }
            } catch (error) {
                console.error("Error determining steps:", error);
                this.stepItems = [...baseSteps, finalStep]; // Fallback to no payment step on error
                this.swalErr('เกิดข้อผิดพลาดในการตรวจสอบขั้นตอนการชำระเงิน');
            }
        },
        async goNext() {
            // 1. ตรวจสอบ (Validate) ข้อมูล
            if (!this.files.attachBAC.length) return this.swalErr('กรุณาแนบรูปถ่ายหน้าตรง');

            this.Loading = true;

            if (!this.$store.state.BuildingAccessCard.uploadfile) {
                this.$store.state.BuildingAccessCard.uploadfile = {};
            }
            if (!this.$store.state.BuildingAccessCard.uploadfile.files) {
                this.$store.state.BuildingAccessCard.uploadfile.files = {};
            }
            this.$store.state.BuildingAccessCard.uploadfile.files.attachBAC = this.files.attachBAC;

            try {
                // Create FormData
                const formData = new FormData();
                formData.append('REQ_TYPE', this.$store.state.BuildingAccessCard.REQ_TYPE);
                formData.append('PICKUP_TYPE', this.$store.state.BuildingAccessCard.PICKUP_TYPE);
                for (const file of this.$store.state.BuildingAccessCard.uploadfile.files.attachBAC) {
                    formData.append('attachBAC', file);
                }

                let requiresPayment = false;
                const reqType = this.$store.state.BuildingAccessCard.REQ_TYPE;

                if (reqType === 'REP') {
                    requiresPayment = true;
                } else { // 'NEW' or 'REN'
                    const AuthorizeToken = localStorage.getItem("AuthorizeToken");
                    const response = await http.get('AgencyERequest/CheckPaymentByAgLavel', { headers: { Authorization: `Bearer ${AuthorizeToken}` } });
                    requiresPayment = response.data === true;
                }

                formData.append('PAYMENT_FLG', requiresPayment ? 'Y' : 'N');

                // Save data
                const saveResult = await this.saveCardRequest(formData);

                if (saveResult.success) {
                    if (requiresPayment) {
                        this.$router.replace('/BACPayment');
                    } else {
                        // this.currentStep = 4;

                        Swal.fire({
                            icon: 'success',
                            title: 'ส่งข้อมูลสำเร็จ',
                            text: 'ระบบได้บันทึกข้อมูลเรียบร้อยแล้ว',
                            customClass: {
                                popup: 'swal-wide',
                                confirmButton: 'btn-bla'
                            }
                        }).then(() => {
                            this.$router.replace('/BACSuccess');
                        });
                    }
                }

            } catch (error) {
                console.error("Error in goNext logic:", error);
                this.swalErr('เกิดข้อผิดพลาดในการดำเนินการ');
            } finally {
                this.Loading = false;
            }
        },
        async saveCardRequest(formData) {
            const AuthorizeToken = localStorage.getItem("AuthorizeToken");
            try {
                const saveResponse = await fetch(process.env.VUE_APP_URL_API + "AgencyERequest/SaveBuildingAccessCard", {
                    method: "POST",
                    headers: { Authorization: `Bearer ${AuthorizeToken}` },
                    body: formData
                });

                if (saveResponse.ok) {
                    return { success: true };
                } else {
                    const errorData = await saveResponse.json().catch(() => null);
                    this.swalErr(errorData?.ErrorMessage || 'ไม่สามารถบันทึกข้อมูลได้ กรุณาติดต่อเจ้าหน้าที่');
                    return { success: false };
                }
            } catch (saveError) {
                console.error("Error saving data:", saveError);
                this.swalErr('เกิดข้อผิดพลาดในการบันทึกข้อมูล');
                return { success: false };
            }
        },
        GetRequestDoc() {
            let AuthorizeToken = localStorage.getItem("AuthorizeToken");
            http.get(`AgencyERequest/GetRequestDocsV1?reqCodeID=${this.reqCodeID}`, { headers: { Authorization: `Bearer ${AuthorizeToken}` } }).then((response) => {
                if (response.status == 200) {
                    this.manangeFiles.attachBAC.LIMIT_AMOUNT_FILE = response.data[0].LIMIT_AMOUNT_FILE;
                    this.manangeFiles.attachBAC.LIMIT_FILE_SIZE = response.data[0].LIMIT_FILE_SIZE;
                    this.manangeFiles.attachBAC.REMARK = response.data[0].REMARK;

                    this.Loading = false;
                }
                else {
                    this.Loading = false;
                    Swal.fire({
                        icon: 'error',
                        html: `<label class="fs-4 fw-normal font-family">${response.data.ErrorMessage}</label>`,
                        customClass: {
                            popup: 'swal-wide',
                            confirmButton: 'btn-bla btn-pill'
                        }
                    });
                    return;
                }
            }).catch((error) => {
                this.Loading = false;
                console.error(error);
                Swal.fire({
                    icon: 'error',
                    html: '<label class="fs-4 fw-normal font-family">ไม่สามารถเชื่อมต่อ API ได้ กรุณาลองใหม่อีกครั้ง</label>',
                    customClass: {
                        popup: 'swal-wide',
                        confirmButton: 'btn-bla btn-pill'
                    }
                });
                return;
            });
        },

        addBACFiles(list) {
            const add = Array.from(list || []);
            if (!add.length) return;

            const amtLimit = this.manangeFiles.attachBAC.LIMIT_AMOUNT_FILE;
            const sizeLimitMb = this.manangeFiles.attachBAC.LIMIT_FILE_SIZE;

            // วนลูปเช็คเงื่อนไขทีละไฟล์
            for (const f of add) {
                const ext = f.name.split('.').pop().toLowerCase();
                if (!['jpg', 'jpeg', 'png'].includes(ext)) {
                    return this.swalErr('รองรับไฟล์ .JPG .JPEG .PNG เท่านั้น');
                }
                if (f.size < 200 * 1024) { // 200 KB
                    return this.swalErr(`ขนาดไฟล์ ${f.name} ต้องมีขนาด 200 KB ขึ้นไป`);
                }
                if (f.size > this.mbToBytes(sizeLimitMb)) {
                    return this.swalErr(`ขนาดไฟล์ ${f.name} เกิน ${sizeLimitMb} MB`);
                }
            }

            // ตรวจสอบจำนวนไฟล์รวมว่าเกิน Limit หรือไม่
            if (this.files.attachBAC.length + add.length > amtLimit) {
                return this.swalErr(`อัปโหลดได้สูงสุด ${amtLimit} ไฟล์`);
            }

            // ตรวจสอบขนาดไฟล์รวมทั้งหมด
            const totalBytes = this.totalSize(this.files.attachBAC) + this.totalSize(add);
            if (totalBytes > this.mbToBytes(sizeLimitMb)) {
                return this.swalErr(`ขนาดไฟล์รวมกันต้องไม่เกิน ${sizeLimitMb} MB`);
            }

            this.files.attachBAC = [...this.files.attachBAC, ...add];
        },
        removeBAC(index) {
            this.files.attachBAC.splice(index, 1);
        },
        // ---------- Helpers ----------
        isServerFile(item) { return !!item.isServer; },
        isPdf(item) { return (item.type || item.mime || '').includes('pdf') || /\.pdf$/i.test(item.name); },
        isImage(item) { return (item.type || item.mime || '').startsWith('image/') || /\.(jpg|jpeg|png)$/i.test(item.name); },

        mbToBytes(mb) { return mb * 1024 * 1024; },
        totalSize(files) { return files.reduce((s, f) => s + f.size, 0); },
        formatFileSize(size) {
            if (!size && size !== 0) return '';
            if (size < 1024) return size + ' B'
            if (size < 1024 * 1024) return Math.round(size / 1024) + ' KB'
            return (size / (1024 * 1024)).toFixed(2) + ' MB'
        },
        swalErr(msg) {
            Swal.fire({
                icon: 'error',
                html: `<label class="fs-5 fw-normal font-family-bla">${msg}</label>`,
                customClass: {
                    popup: 'swal-wide',
                    confirmButton: 'btn-bla'// pv-btn-primary
                }
            })
        },
        Authorization() {
            this.Loading = true;

            let AuthorizeToken = localStorage.getItem("AuthorizeToken");
            http.get("AgencyERequest/GetName", { headers: { Authorization: `Bearer ${AuthorizeToken}` } }).then((response) => {
                if (response.status == 200) {
                    this.Loading = false;

                    this.$store.state.UserName = response.data.NAME + " " + response.data.SURNAME;
                    this.$store.state.AgentCode = response.data.AGENTCODE;
                }
                else {
                    localStorage.removeItem("Token");
                    localStorage.removeItem("AuthorizeToken");
                    window.open(process.env.VUE_APP_URL_ADFS, '_self');
                }
            }).catch((error) => {
                Swal.fire({
                    icon: 'error',
                    html: '<label class="fs-4 fw-normal font-family">' + error.response.data.ErrorMessage + '</label>',
                }).then(() => {
                    localStorage.removeItem("Token");
                    localStorage.removeItem("AuthorizeToken");
                    window.open(process.env.VUE_APP_URL_ADFS + "Logout", '_self');
                });
            });
        },
    },
};

</script>

<style scoped>
/* โทนฟอนต์และกรอบให้เหมือน template ที่ให้มา */
.font-family-bla {
    font-family: "DB Heavent", sans-serif;
}

.card-wrap {
    border: 2px solid #A2B9E2;
    border-radius: 10px;
    background: #fff;
}

/* ให้ตัวอักษรของ input/textarea readonly & disabled เป็นสี #6D8EC9 */
.form-control[readonly],
textarea[readonly],
.form-control:disabled,
textarea:disabled,
.form-control-plaintext {
    color: #6D8EC9 !important;
    /* background-color: var(--bs-body-tertiary) !important; */
    cursor: default;
}

/* ปุ่ม: เต็มความกว้างบนมือถือ และกว้างพอดีบนจอใหญ่ */
.btn-confirm {
    width: 100%;
}

@media (min-width: 768px) {
    .btn-confirm {
        width: 25%;
        min-width: 160px;
        max-width: 320px;
    }
}

/* กรอบแดงไม่มี bg */
.alert-red-border {
    border: 2px solid var(--bs-danger);
    border-radius: 10px;
}

/* ===== Inline label + control ===== */
.inline-field {
    --label-w: 9.5rem;
    /* ปรับความกว้าง label ได้ตามต้องการ */
    display: flex;
    align-items: center;
    gap: .75rem;
}

.inline-label {
    flex: 0 0 var(--label-w);
    max-width: 50%;
    font-weight: 600;
}

.inline-control {
    flex: 1 1 auto;
    min-width: 0;
    /* กัน overflow */
}

/* มือถือ: ซ้อนเป็นแนวตั้งให้ใช้งานง่าย */
@media (max-width: 575.98px) {
    .inline-field {
        flex-direction: column;
        align-items: stretch;
    }

    .inline-label {
        flex: 0 0 auto;
        max-width: 100%;
    }
}

.required {
    color: #d9534f;
}

.action-bar {
    display: flex;
    justify-content: space-around;
    gap: 12px;
    border-top: 1px solid #eef1f4;
    padding-top: 18px;
}

.instructions {
    /* margin: 0 0 24px; */
    padding-left: 0;
    color: #3c3c3c;
    font-size: 22px;
    line-height: 1.55;
    list-style-position: inside;
}

.training-page {
    min-height: 100svh;
    background: #ffffff;
    padding: 28px 30px;
}

.training-panel {
    display: flex;
    min-height: calc(100svh - 56px);
    flex-direction: column;
    background: #ffffff;
}

.page-header {
    border-bottom: 1px solid #d7dde3;
    padding-bottom: 14px;
}

.page-header h1 {
    display: inline-block;
    margin: 0;
    color: #138000;
    background: #fff829;
    border: 1px solid #e4cc00;
    font-size: 28px;
    font-weight: 600;
    line-height: 1.35;
    padding: 3px 10px;
}

.form-content {
    flex: 1;
    padding-top: 18px;
}

.form-content h2,
.qualification-title {
    margin: 0 0 6px;
    color: #0057ad;
    font-size: 22px;
    font-weight: 700;
    line-height: 1.35;
}


.field-label {
    display: block;
    color: #111111;
    font-size: 22px;
    font-weight: 700;
    line-height: 1.2;
}


.form-section {
    margin-top: 12px;
}

.required {
    color: #d00000;
}

.field-help {
    margin: 4px 0 0;
    color: #111111;
    font-size: 17px;
    line-height: 1.35;
}

.field-note {
    margin: 3px 0 6px;
    color: #8b8b8b;
    font-size: 15px;
    line-height: 1.35;
}

.upload-button {
    width: 114px;
    height: 46px;
    border: 2px solid #b7b7b7;
    background: #ffffff;
    color: #0057ad;
    font-size: 18px;
    font-weight: 700;
}

.form-grid {
    display: grid;
    gap: 18px;
    max-width: 680px;
    margin-top: 14px;
}

.form-field {
    min-width: 0;
}

.text-input {
    width: 100%;
    border: 0;
    border-bottom: 1px solid #a8a8a8;
    border-radius: 0;
    color: #222222;
    font-size: 20px;
    line-height: 1.4;
    outline: 0;
    padding: 5px 2px;
}

.text-input::placeholder {
    color: #b4b4b4;
}

.date-input-wrap {
    position: relative;
    display: flex;
    align-items: center;
}

.date-input-wrap .text-input {
    padding-right: 46px;
}

.calendar-icon {
    position: absolute;
    right: 5px;
    top: 50%;
    transform: translateY(-50%);
    color: #0057ad;
    font-size: 20px;
    pointer-events: none;
}

.native-date {
    position: absolute;
    right: 0;
    bottom: 0;
    width: 1px;
    height: 1px;
    opacity: 0;
    pointer-events: none;
}

.character-count {
    margin-top: 3px;
    color: #a0a0a0;
    font-size: 14px;
    text-align: right;
}

.certify-box {
    max-width: 880px;
    margin-top: 10px;
    /* border: 1px solid #ffb075; */
    border-left: 0;
    border-top: 0;
    padding: 0 0 12px;
}

.certify-box p {
    margin: 0 0 0px;
    color: #111111;
    font-size: 17px;
    line-height: 1.45;
}

.confirm-check {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    color: #111111;
    cursor: pointer;
    font-size: 18px;
    font-weight: 700;
}

.selected-summary {
    margin: 14px 0 10px;
    color: #2f2f2f;
    font-size: 22px;
}

.action-button {
    min-width: 128px;
    border-radius: 4px;
    font-size: 20px;
    font-weight: 600;
}

@media (max-width: 768px) {
    .training-page {
        padding: 20px 16px;
    }

    .training-panel {
        min-height: calc(100svh - 40px);
    }

    .page-header h1 {
        font-size: 24px;
    }

    .form-content h2,
    .qualification-title {
        font-size: 20px;
    }

    .field-label {
        font-size: 20px;
    }

    .certify-box {
        border-right: 0;
    }

    .action-bar {
        flex-direction: column-reverse;
    }

    .action-button {
        width: 100%;
    }
}

@media (max-width: 480px) {
    .training-page {
        padding: 16px 12px;
    }

    .training-panel {
        min-height: calc(100svh - 32px);
    }

    .page-header h1 {
        font-size: 22px;
    }

    .instructions,
    .field-help,
    .certify-box p {
        font-size: 16px;
    }

    .text-input {
        font-size: 18px;
    }
}

.file-list-scroll {
    max-height: 250px;
    overflow-y: auto;
    border: 1px solid #eef1f4;
    border-radius: 6px;
    padding: 8px;
    background: #f8fbff;
}

.file-chip {
    border: 1px solid #d1e3ff;
    background: #e7f1ff;
    border-radius: 10px;
    padding: .5rem .75rem;
}
</style>
